export default __webpack_public_path__ + "static/media/alert.b69d99af.svg";